<script>
  import { surveyStore } from '../../stores/surveyStore.js';
  import { GA4Events } from '../../services/api.js';
  
  export let questionData;
  export let questionNumber; // 'q1', 'q2', 'q3', 'q4'
  export let onBack = null;
  export let onNext = null;
  
  function handleAnswer(option) {
    // Save answer
    surveyStore.setAnswer(questionNumber, option.tag, option.text);
    
    // Track GA4 event
    const qNum = parseInt(questionNumber.substring(1));
    GA4Events.questionAnswered(qNum, option.tag);
    
    // Navigate to next question or loading screen
    if (onNext) {
      onNext();
    }
  }
</script>

<div class="card">
  <div class="card-eyebrow">{questionData.eyebrow}</div>
  <h2 class="card-title">{@html questionData.title}</h2>
  <div class="card-body">
    <p>{questionData.body}</p>
  </div>
  
  <div class="answers">
    {#each questionData.options as option}
      <button
        class="answer-btn {option.className || ''}"
        on:click={() => handleAnswer(option)}
      >
        <span class="answer-marker">{option.marker}</span>
        <span class="answer-text">
          <strong>{option.text}</strong>
          {#if option.small}
            <small>{option.small}</small>
          {/if}
        </span>
      </button>
    {/each}
  </div>
  
  {#if onBack}
    <button class="back-btn" style="margin-top: 1.25rem;" on:click={onBack}>
      ← Back
    </button>
  {/if}
</div>
